import { Popover, Tooltip } from "antd";
import { useState } from "react";
import { FilterPanelContent } from "./FilterPanelContent.tsx";
import "./FilterPanel.scss";
import { useIntl } from "react-intl";
import type { DataTableFilter } from "../../types/dataTableFilter.ts";

type FilterPanelProps = {
  filters: DataTableFilter[];
  onChangeFilters: (filterKey: string, values: any) => void;
  currentFilter: Record<string, any>;
};
export const FilterPanel = ({ filters, onChangeFilters, currentFilter }: FilterPanelProps) => {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const { formatMessage } = useIntl();
  return (
    <div>
      <Popover
        styles={{ body: { padding: "16px" } }}
        arrow={false}
        trigger="click"
        placement="bottomLeft"
        open={filtersOpen}
        onOpenChange={setFiltersOpen}
        content={<FilterPanelContent filters={filters} onChangeFilters={onChangeFilters} currentFilter={currentFilter} />}
      >
        <Tooltip title={formatMessage({ id: "dataTable.filters.filterpanel" })}>
          <div>
            <i className="fa-solid fa-sliders gear-icon"></i>
          </div>
        </Tooltip>
      </Popover>
    </div>
  );
};
